import React from 'react';
import { Form, Select } from 'antd';

const { Option } = Select;

const SelectOption = ({
  label,
  name,
  rules,
  isMultiple,
  placeholder,
  values,
  valueName,
  labelName,
  handleOnSelect,
  handleOnDeselect,
  defaultValue = null,
  value = null
}) => {
  return (
    <Form.Item label={label} name={name} rules={rules}>
      <Select
        mode={isMultiple ? 'multiple' : 'single'}
        placeholder={placeholder}
        onSelect={handleOnSelect}
        onDeselect={handleOnDeselect}
        value={value}
        defaultValue={defaultValue}
      >
        {values.map((value, index) => {
          return (
            <Option key={index} value={valueName ? value[valueName] : value}>
              {labelName ? value[labelName] : value}
            </Option>
          );
        })}
      </Select>
    </Form.Item>
  );
};

export default SelectOption;
